<template>
  <main class="push-campaign-notification-creator">
    <div class="editor-container">
      <span class="push-notification-text">push notification message</span>

      <editor
        :value="pushNotificationEditor"
        @update:value="updatePushNotificationEditor"
        ref="editor"
        class='notification-editor border-can-error'
        v-touch:push_notification_content
        v-has-error:push_notification_content
      />

      <notification-substitution
        class="border-can-error"
        @shouldInsertFirstName="shouldInsertFirstName"
        v-has-error:push_notification_content
      />
      
      <div class="flex">
        <div>*optimized character count for iOS devices is 175</div>
        <div class="ml-auto">{{charactersForPushNotificationContent}}/240</div>
      </div>
    </div>
  </main>
</template>

<script>
import Editor from "./editor";
import NotificationSubstitution from "./push-notification-substitution/notification-substitution";
import { Touch, HasError } from "@springbig/sb-components";


export default {
  name: "push-campaign-notification-creator",
  directives: {Touch, HasError},
  components: {Editor, NotificationSubstitution},

  props: {
    campaign: Object,
    pushNotificationEditor: String,
    charactersForPushNotificationContent: Number
  },

  methods: {
    shouldInsertFirstName(text) {
      this.$refs.editor.insertText(text);
    },
    async updatePushNotificationEditor(text) {
      this.$emit("update:push-notification-editor", text);
    }
  },

  computed: {
    invalidText() { return this.$store.getters.hasError('push_notification_content'); },
  }
}
</script>

<style scoped>
.campaign-creator {
  display:flex;
  flex-direction: column;
  flex-wrap: nowrap;
}

.editor-container {
  display:flex;
  flex-direction: column;
  width: 100%;
}

.push-notification-text {
  margin-top: 30px;
  font-size: 1.25rem;
  font-weight: bold;
  color: #4A4A4A;
}

.notification-editor {
  height: 80px;
  border-radius: 16px 16px 0 0;
}
</style>
